import { c as _c } from "react/compiler-runtime";
import EventsSkeleton from 'modules/main/components/event-box-section/events-skeleton';
import { EventBoxSectionProps } from 'modules/main/components/event-box-section/types';
import RenderEvent from 'modules/main/components/render-event';
import { useMain } from 'modules/main/hooks/use-main';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const EventBoxSection = React.forwardRef<HTMLDivElement, React.PropsWithChildren<EventBoxSectionProps>>(function EventBoxSection(t0, ref) {
  const $ = _c(17);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    events,
    revenue
  } = useMain(filter);
  const eventsData = events?.items;
  const hasEvents = eventsData?.length !== 0;
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.main.event.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-primary font-inter px-[25px] py-[23px] text-[20px] font-bold">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <hr className="color-[rgb(var(--background-tertiary))] opacity-10" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== eventsData || $[6] !== hasEvents || $[7] !== revenue) {
    t4 = eventsData ? hasEvents && <><div className="flex flex-col gap-3 overflow-hidden px-[25px] pb-5"><ul className="flex flex-col">{eventsData.map((event, idx) => <li key={idx}><RenderEvent event={event} lastItem={idx === eventsData.length - 1} /></li>)}</ul></div></> : <EventsSkeleton revenueLength={Object.keys(revenue || []).length} />;
    $[5] = eventsData;
    $[6] = hasEvents;
    $[7] = revenue;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="static flex w-full flex-col lg:absolute">{t2}{t3}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hasEvents) {
    t6 = hasEvents && <div className="absolute bottom-0 hidden h-[50px] w-[326px] rounded-lg bg-gradient-to-b from-[hsla(0,0%,100%,0)] to-[var(--color-background-secondary)] lg:block" />;
    $[12] = hasEvents;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="bg-background-secondary shadow-old-design relative min-h-[700px] w-full flex-none overflow-hidden rounded-lg lg:w-[326px]">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
});